import { environment } from "src/environments/environment";

/** Path do WS no frontend (proxy ng serve / nginx). REST usa apiBaseUrl via gateway. */
export const analyzeTripWsPath =
  environment.apisConfig.seteraAnalyzeTrip.wsPath ||
  "/ws/analyze-report/operator";

export const WS_KC_AUTH_SUBPROTOCOL = "kc-auth";

export function isAnalyzeTripLocalDirectWs(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1";
}

/**
 * Local: WS direto no analyze-trip (:8081) com kc-auth na query (browser nao envia header).
 * Deploy: mesma origem do front — cookie + nginx/proxy injetam kc-auth.
 */
export function shouldPassKcAuthInWsQuery(): boolean {
  return isAnalyzeTripLocalDirectWs();
}

/** Mesma origem do frontend; override só se wsUrl absoluto for necessário. */
export function resolveAnalyzeTripWsBaseUrl(): string {
  const configured = (environment.apisConfig.seteraAnalyzeTrip.wsUrl || "").trim();
  if (configured.startsWith("ws://") || configured.startsWith("wss://")) {
    return configured.replace(/\/ws\/.*$/, "");
  }

  if (isAnalyzeTripLocalDirectWs()) {
    return environment.apisConfig.seteraAnalyzeTrip.apiBaseUrl
      .replace(/^http:/, "ws:")
      .replace(/^https:/, "wss:")
      .replace(/\/$/, "");
  }

  const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
  return `${protocol}//${window.location.host}`;
}

export function resolveAnalyzeTripWsUrl(): string {
  const configured = (environment.apisConfig.seteraAnalyzeTrip.wsUrl || "").trim();
  if (configured.startsWith("ws://") || configured.startsWith("wss://")) {
    if (/^wss:\/\/(localhost|127\.0\.0\.1)(:\d+)?/i.test(configured)) {
      return configured.replace(/^wss:/i, "ws:");
    }
    return configured;
  }
  return `${resolveAnalyzeTripWsBaseUrl()}${analyzeTripWsPath}`;
}
